export default ".text-p {\n  width: 100%;\n}\n\np {\n  text-align: justify;\n}\n\n.datasetLink {\n  color: black;\n}";